<template>
    <div class="approve_admin_management_wrap">
        <div class="admin_management_top">
<!--            <div class="admin_management_top_return" @click="handleClickReturn">-->
<!--                <i class="el-icon-arrow-left"></i> 返回-->
<!--            </div>-->
            <div class="admin_management_top_tab">
                <ul>
                    <li @click="handleClickTab(item)" :class="item.name == activeName ? 'active' : ''" v-for="item in tabList" v-text="item.label"></li>
                </ul>
            </div>
            <div class="admin_management_top_save">
            </div>
        </div>
        <div class="admin_management_bottom">
            <div v-show="activeName === 'ApprovalSettings'">
                <approvalSettings></approvalSettings>
            </div>
            <div v-show="activeName === 'ApprovalHandover'">
                <approvalHandover></approvalHandover>
            </div>
        </div>
    </div>
</template>
<script>
import approvalSettings from './approvalSettings'
import approvalHandover from './approvalHandover'
export default {
    name: "approveAdminManagement",
    components: {
        approvalSettings,
        approvalHandover
    },
    data() {
        return {
            activeName: "ApprovalSettings",
            tabList: [
                { name: "ApprovalSettings", label: "审批设置" },
                { name: "ApprovalHandover", label: "审批交接" },

            ],
        }
    },
    methods: {
        handleClickReturn(){
            this.$router.go(-1)
        },
        handleClickTab(item) {
            this.activeName = item.name;
        },

    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/approval.scss";

</style>
